
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"62.3","height":"41.5","viewBox":"0 0 62.3 41.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#EFECD5"}},[_c('path',{attrs:{"d":"M1.3 15.9V37.1c0 2.4 2.5 3.6 4.9 3.6h51.2c2.4 0 3.7-1.2 3.7-3.6V15.9H1.3zm22 19.3H4.9v-2.8h18.4v2.8zm7.4-5.5H4.9v-2.8h25.8v2.8zM61 4.8C60.8 2.5 58.9.7 56.6.7H5.7C3.4.7 1.5 2.5 1.3 4.8v5.6H61V4.8z"}})])])
          )
        }
      }
    